export enum EBackupImage {
  COMPANY = 'COMPANY',
  FILE = 'FILE',
  WORD = 'WORD',
  EXCEL = 'EXCEL',
  PPT = 'PPT',
  PDF = 'PDF',
  USER = 'USER',
  UPLOAD = 'UPLOAD',
  VIDEO = 'VIDEO',
  OTHER = 'OTHER',
}
